import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    id="Grupo_1809"
    data-name="Grupo 1809"
    width="102.461"
    height="104.476"
    viewBox="0 0 102.461 104.476"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="-8.426"
        y1="0.5"
        x2="1.166"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#00efd1" />
        <stop offset="1" stopColor="#00acea" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="-0.027"
        y1="0.5"
        x2="1.102"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1="-6.704"
        y1="0.5"
        x2="0.872"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-4"
        x1="-1.931"
        y1="0.5"
        x2="7.236"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-5"
        x1="-0.863"
        y1="0.5"
        x2="3.608"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-6"
        x1="-9.071"
        y1="0.5"
        x2="0.528"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-7"
        x1="-8.58"
        y1="0.5"
        x2="1.019"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-8"
        x1="-3.533"
        y1="0.5"
        x2="7.373"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-9"
        x1="-5.678"
        y1="0.5"
        x2="6.132"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-10"
        x1="-2.456"
        y1="0.5"
        x2="5.506"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-11"
        x1="-0.944"
        y1="0.5"
        x2="6.182"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-12"
        x1="-3.793"
        y1="0.5"
        x2="8.06"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-13"
        x1="-4.798"
        y1="0.5"
        x2="5.909"
        y2="0.5"
        xlinkHref="#linear-gradient"
      />
    </defs>
    <path
      id="Caminho_314"
      data-name="Caminho 314"
      d="M-152.53,565.426a5.187,5.187,0,0,0-5.242,5.112,5.234,5.234,0,0,0,5.224,5.254,5.243,5.243,0,0,0,5.19-5.189A5.169,5.169,0,0,0-152.53,565.426Zm-.024,7.276a2.125,2.125,0,0,1-2.115-2.151,2.071,2.071,0,0,1,2.2-2.041,2.1,2.1,0,0,1,2.021,2.135A2.129,2.129,0,0,1-152.554,572.7Z"
      transform="translate(243.173 -483.428)"
      fill="url(#linear-gradient)"
    />
    <path
      id="Caminho_315"
      data-name="Caminho 315"
      d="M-291.632,428.795c.3,0,.7.421.873.742a5.258,5.258,0,0,0,5.932,2.707,5.153,5.153,0,0,0,3.939-5.066,5.157,5.157,0,0,0-4.01-5.013,5.074,5.074,0,0,0-5.794,2.731,1.26,1.26,0,0,1-1.4.8c-4.217-.017-8.433-.011-12.649-.013h-2.177v-11.15c.913,0,1.758.045,2.6-.013a1.391,1.391,0,0,1,1.551.9,5.143,5.143,0,0,0,8.422,1.063,4.895,4.895,0,0,0,.965-5.409,4.943,4.943,0,0,0-4.665-3.227,5.064,5.064,0,0,0-4.77,2.76c-.186.318-.468.79-.737.813-1.1.093-2.219.039-3.363.039v-8.728a2.271,2.271,0,0,1,.364-.071c5.271,0,10.541-.025,15.811.022a2.608,2.608,0,0,1,1.5.683c.9.777,1.685,1.679,2.547,2.5.836.8,1.672.837,2.345.171a1.581,1.581,0,0,0-.178-2.349c-.849-.881-1.746-1.716-2.6-2.592a4.936,4.936,0,0,0-3.751-1.519c-4.965.027-9.929.01-14.893.01h-1.135a5.055,5.055,0,0,1-.077-.578c0-1.866,0-3.731,0-5.755h1.241c3.638,0,7.277-.019,10.915.009a4.858,4.858,0,0,0,3.657-1.5c1.629-1.641,3.289-3.251,4.9-4.908a1.382,1.382,0,0,1,1.513-.427,5.163,5.163,0,0,0,6.126-3.893,5.168,5.168,0,0,0-3.674-6.173,5.227,5.227,0,0,0-6.363,3.522,5.438,5.438,0,0,0,.6,4.371c-1.814,1.83-3.556,3.645-5.378,5.376a2.482,2.482,0,0,1-1.565.53c-3.706.043-7.412.022-11.118.015-.258,0-.517-.047-.768-.072V380.046c.939,0,1.787.031,2.632-.011a1.046,1.046,0,0,1,1.148.713,5.088,5.088,0,0,0,5.941,2.8,5.24,5.24,0,0,0,3.967-5.069,5.273,5.273,0,0,0-3.948-4.985,5.255,5.255,0,0,0-5.939,2.692c-.157.3-.422.728-.665.747-1.036.084-2.083.035-3.169.035-.038-.417-.076-.715-.091-1.013a12.287,12.287,0,0,0-9.591-11.171,12.331,12.331,0,0,0-13.276,5.777,1.767,1.767,0,0,1-1.782,1.1,12.77,12.77,0,0,0-11.861,8.293,39.466,39.466,0,0,0-1.08,4.266,12.707,12.707,0,0,0-11.758,4.763c-3.034,3.747-3.606,8.014-2.113,12.6-.684.488-1.374.923-2,1.436a17.543,17.543,0,0,0,1.316,28.32,1.084,1.084,0,0,1,.485,1.479,12.518,12.518,0,0,0,2.36,11.878c.739.931,1.652,1.117,2.374.55.746-.585.722-1.391.058-2.447a14.944,14.944,0,0,1-1.706-3.1c-1.558-4.7-.008-8.759,4.332-11.7,1.014-.687,1.3-1.495.8-2.3a1.544,1.544,0,0,0-2.4-.283c-1.457,1.089-2.819,2.3-4.342,3.565.168.058.064.041-.019-.009a14.554,14.554,0,0,1-6.645-14.149A14.417,14.417,0,0,1-353.4,402.794a33.616,33.616,0,0,1,3.809-.6c1.088-.148,1.708-.666,1.734-1.52a1.483,1.483,0,0,0-1.752-1.524c-2.01.2-4.007.53-6.059.812-1.917-4.37,1.094-10.519,6.056-12.177a10.916,10.916,0,0,1,6.216-.182c1.337.326,2.1-.327,2.1-1.682,0-.442-.048-.883-.052-1.325a10.124,10.124,0,0,1,6.45-9.286,10.094,10.094,0,0,1,11.4,3.373,10.184,10.184,0,0,1,1.977,5.681,1.592,1.592,0,0,0,1.623,1.72c.908-.058,1.47-.767,1.43-1.875a12.227,12.227,0,0,0-4.335-9.217,42.539,42.539,0,0,0-4.372-2.922c1.581-3.36,6.354-5.327,10.293-4.146,4.227,1.268,7.2,5.242,6.659,9-.8,0-1.609-.011-2.419,0-1.187.02-1.881.61-1.863,1.562.018.917.683,1.478,1.819,1.5.84.017,1.681,0,2.53,0v10.165c-4.261,0-8.442.087-12.617-.032-2.618-.074-4.378-2.015-4.7-4.761-.138-1.193-.753-1.8-1.721-1.713-.912.086-1.383.768-1.33,1.929a8.12,8.12,0,0,0,8.35,7.661c3.6.038,7.209.012,10.813.014h1.208v25.726h-1.082q-11.425,0-22.85,0c-.436,0-1-.064-1.279.169a2.636,2.636,0,0,0-.982,1.476,1.3,1.3,0,0,0,1.236,1.377,7.461,7.461,0,0,0,1.119.038q11.324,0,22.646,0h1.211v21.01c-1.1,0-2.15-.069-3.189.017a20.045,20.045,0,0,0-4.206.571,7.561,7.561,0,0,0-5.052,7.082,1.537,1.537,0,0,0,1.334,1.653,1.55,1.55,0,0,0,1.663-1.323,6.349,6.349,0,0,0,.085-.707,4.423,4.423,0,0,1,3.629-4.017,49.5,49.5,0,0,1,5.716-.047v11.117c-1.02,0-1.971-.061-2.909.017a1.452,1.452,0,0,0-1.429,1.549,1.467,1.467,0,0,0,1.531,1.447c.63.038,1.265.007,2.088.007a9.223,9.223,0,0,1-7.671,5.409,9.031,9.031,0,0,1-8.734-4.594,6.324,6.324,0,0,0,.723-.339c1.344-.845,2.726-1.64,4-2.578a1.423,1.423,0,0,0,.246-2.16,1.523,1.523,0,0,0-2.188-.149c-.3.216-.571.484-.873.7a9.568,9.568,0,0,1-10.1,1.178,9.638,9.638,0,0,1-5.886-8.517,1.154,1.154,0,0,1,.811-1.307,16,16,0,0,0,2.249-1.382,1.584,1.584,0,0,0,.625-2.269A1.55,1.55,0,0,0-340,444.2a10.953,10.953,0,0,1-6.962,2.175,1.511,1.511,0,0,0-1.772,1.534c0,.94.612,1.476,1.784,1.516.835.029,1.672.006,2.5.006a12.954,12.954,0,0,0,12.9,12.391,1.6,1.6,0,0,1,1.622,1.014,12.313,12.313,0,0,0,13.351,5.8,12.186,12.186,0,0,0,9.564-11.815c.032-1.144,0-2.29,0-3.53,2.748,0,5.357-.029,7.965.03a2.181,2.181,0,0,1,1.209.658c.9.825,1.724,1.739,2.628,2.563a1.031,1.031,0,0,1,.3,1.47,4.339,4.339,0,0,0-.2,3.372,5.173,5.173,0,0,0,6.335,3.542,5.187,5.187,0,0,0,3.673-6.354,5.179,5.179,0,0,0-6.372-3.628,1.229,1.229,0,0,1-1.418-.384c-.913-.961-1.886-1.866-2.8-2.822a4.9,4.9,0,0,0-3.751-1.532c-2.108.015-4.216.007-6.325,0-.391,0-.781-.033-1.165-.05v-8.02a1.922,1.922,0,0,1,.359-.082c4.08-.006,8.161-.024,12.241.02a1.35,1.35,0,0,1,.913.682,5.262,5.262,0,0,0,5.776,2.853,5.249,5.249,0,0,0,4.155-5.127,5.233,5.233,0,0,0-3.933-4.986,5.107,5.107,0,0,0-5.948,2.792,1.061,1.061,0,0,1-1.151.7c-3.876-.019-7.753-.009-11.629-.013-.259,0-.517-.047-.77-.072V428.762C-301.76,428.762-296.7,428.749-291.632,428.795Zm5.566-3.687a2.124,2.124,0,0,1,2.1,2.146,2.154,2.154,0,0,1-2.174,2.085,2.2,2.2,0,0,1-2.074-2.1A2.189,2.189,0,0,1-286.065,425.108Zm-12.146-14.2a2.178,2.178,0,0,1,2.148,2.12,2.161,2.161,0,0,1-2.183,2.08,2.1,2.1,0,0,1-2.075-2.161A2.13,2.13,0,0,1-298.212,410.91Zm14.459-31.66a2.192,2.192,0,0,1,2.188,2.082,2.161,2.161,0,0,1-2.134,2.133,2.119,2.119,0,0,1-2.122-2.023A2.159,2.159,0,0,1-283.753,379.25Zm-14.643-2.841a2.195,2.195,0,0,1,2.084,2.108,2.133,2.133,0,0,1-2.179,2.1,2.08,2.08,0,0,1-2.062-2.086A2.139,2.139,0,0,1-298.4,376.409Zm8.3,81.411a2.116,2.116,0,0,1,2.089,2.154,2.1,2.1,0,0,1-2.182,2.054,2.1,2.1,0,0,1-2.039-2.194A2.136,2.136,0,0,1-290.1,457.82Zm1.422-19.416a2.152,2.152,0,0,1,2.1,2.157,2.144,2.144,0,0,1-2.179,2.072,2.141,2.141,0,0,1-2.05-2.1A2.165,2.165,0,0,1-288.678,438.4Z"
      transform="translate(367.053 -364.483)"
      fill="url(#linear-gradient-2)"
    />
    <path
      id="Caminho_316"
      data-name="Caminho 316"
      d="M-149.829,477.545a1.129,1.129,0,0,1-1.411-.333c-.716-.771-1.468-1.512-2.241-2.228a1.542,1.542,0,0,0-2.271-.079,1.562,1.562,0,0,0,.154,2.269c.724.765,1.465,1.516,2.236,2.232a1.06,1.06,0,0,1,.319,1.32,4.847,4.847,0,0,0,1.346,5.479,4.9,4.9,0,0,0,5.58.959,4.849,4.849,0,0,0,3.133-4.43A5.192,5.192,0,0,0-149.829,477.545Zm3.766,4.951a2.077,2.077,0,0,1-2.2,2.02,2.123,2.123,0,0,1-2.033-2.111,2.11,2.11,0,0,1,2.174-2.068A2.066,2.066,0,0,1-146.063,482.5Z"
      transform="translate(242.225 -429.573)"
      fill="url(#linear-gradient-3)"
    />
    <path
      id="Caminho_317"
      data-name="Caminho 317"
      d="M-317.857,445.753c-.708.213-1.472.23-2.193.408a1.426,1.426,0,0,0-.811,2.367,5.429,5.429,0,0,0,1.642.76l.1-.177c.5-.078,1.015-.114,1.5-.241a9.269,9.269,0,0,0,4.718-15.427,8.886,8.886,0,0,0-6.694-2.975,1.48,1.48,0,0,0-1.625,1.343,1.493,1.493,0,0,0,1.3,1.667,5.376,5.376,0,0,0,.708.072,6.275,6.275,0,0,1,5.757,5.646A6.252,6.252,0,0,1-317.857,445.753Z"
      transform="translate(339.943 -403.542)"
      fill="url(#linear-gradient-4)"
    />
    <path
      id="Caminho_318"
      data-name="Caminho 318"
      d="M-322.559,533.54c.542-3.226,2.127-4.587,5.371-4.591,4.006-.006,8.013.008,12.019-.007,1.262,0,1.957-.618,1.922-1.6-.035-.956-.673-1.456-1.93-1.462-2.173-.011-4.346,0-6.519,0v.05c-2.24,0-4.485-.088-6.72.02a7.646,7.646,0,0,0-7.169,7.276c-.06,1.183.387,1.835,1.316,1.923C-323.32,535.23-322.753,534.7-322.559,533.54Z"
      transform="translate(342.51 -460.014)"
      fill="url(#linear-gradient-5)"
    />
    <path
      id="Caminho_319"
      data-name="Caminho 319"
      d="M-136.264,526.217a5.253,5.253,0,0,0-5.2,5.181,5.2,5.2,0,0,0,5.277,5.182,5.139,5.139,0,0,0,5.131-5.2A5.212,5.212,0,0,0-136.264,526.217Zm.024,7.289a2.145,2.145,0,0,1-2.153-2.1,2.167,2.167,0,0,1,2.172-2.094,2.136,2.136,0,0,1,2.089,2.063A2.111,2.111,0,0,1-136.24,533.506Z"
      transform="translate(233.521 -460.219)"
      fill="url(#linear-gradient-6)"
    />
    <path
      id="Caminho_320"
      data-name="Caminho 320"
      d="M-153.987,435.527a5.2,5.2,0,0,0,5.256,5.1,5.178,5.178,0,0,0,5.152-5.2,5.187,5.187,0,0,0-5.194-5.16A5.218,5.218,0,0,0-153.987,435.527Zm5.216-2.162a2.12,2.12,0,0,1,2.121,2.042,2.125,2.125,0,0,1-2.127,2.143,2.151,2.151,0,0,1-2.13-2.15A2.143,2.143,0,0,1-148.771,433.366Z"
      transform="translate(240.932 -403.425)"
      fill="url(#linear-gradient-7)"
    />
    <path
      id="Caminho_321"
      data-name="Caminho 321"
      d="M-292.09,554.747a1.474,1.474,0,0,0-1.424,1.647,1.559,1.559,0,0,0,1.732,1.362,7.71,7.71,0,0,0,7.416-7.654c-.049-.409-.092-.884-.165-1.353a7.72,7.72,0,0,0-7.342-6.211A1.558,1.558,0,0,0-293.525,544a1.51,1.51,0,0,0,1.406,1.583c.435.074.881.1,1.305.215a4.513,4.513,0,0,1,2.239,7.333A5.11,5.11,0,0,1-292.09,554.747Z"
      transform="translate(323.53 -469.881)"
      fill="url(#linear-gradient-8)"
    />
    <path
      id="Caminho_322"
      data-name="Caminho 322"
      d="M-253.375,464.623c-1.243.177-1.806.731-1.731,1.7s.749,1.411,2,1.342a7.106,7.106,0,0,0,6.443-6.8,19.883,19.883,0,0,0-1.328-3.453,6.293,6.293,0,0,0-5.415-3.094,1.45,1.45,0,0,0-1.689,1.257,1.449,1.449,0,0,0,1.3,1.733c.231.051.468.076.7.112a3.487,3.487,0,0,1,2.914,2.381C-249.349,462.063-250.822,464.26-253.375,464.623Z"
      transform="translate(300.797 -417.66)"
      fill="url(#linear-gradient-9)"
    />
    <path
      id="Caminho_323"
      data-name="Caminho 323"
      d="M-297.217,464.488c.339.965,1.121,1.077,2,1.013a10.921,10.921,0,0,0,8.665-5,10.335,10.335,0,0,0,1.789-5.755,1.556,1.556,0,0,0-1.394-1.72,1.546,1.546,0,0,0-1.644,1.455c-.06.4-.095.81-.156,1.213a7.22,7.22,0,0,1-3.895,5.637,16.3,16.3,0,0,1-3.862,1.1C-296.934,462.713-297.567,463.491-297.217,464.488Z"
      transform="translate(325.771 -416.892)"
      fill="url(#linear-gradient-10)"
    />
    <path
      id="Caminho_324"
      data-name="Caminho 324"
      d="M-337.374,483.557a1.553,1.553,0,0,0-1.675-1.526,1.557,1.557,0,0,0-1.364,1.737,8.143,8.143,0,0,0,2.9,5.947,8.976,8.976,0,0,0,6.737,1.9c1.125,0,2.008.022,2.89-.006a1.406,1.406,0,0,0,1.477-1.387,1.431,1.431,0,0,0-1.256-1.6,3.709,3.709,0,0,0-.809-.062c-1.052-.007-2.105,0-3.158,0C-335.077,488.555-336.884,486.981-337.374,483.557Z"
      transform="translate(351.286 -434.058)"
      fill="url(#linear-gradient-11)"
    />
    <path
      id="Caminho_325"
      data-name="Caminho 325"
      d="M-293.2,404.117a1.47,1.47,0,0,0,1.709-1.243c.356-2.33,1.715-3.413,4.011-3.519a1.372,1.372,0,0,0,1.424-1.529,1.374,1.374,0,0,0-1.3-1.442,5.235,5.235,0,0,0-.712,0,6.591,6.591,0,0,0-6.4,5.84A1.579,1.579,0,0,0-293.2,404.117Z"
      transform="translate(324.098 -383.357)"
      fill="url(#linear-gradient-12)"
    />
    <path
      id="Caminho_326"
      data-name="Caminho 326"
      d="M-261.664,528.921q3.2.1,6.4,0a1.442,1.442,0,0,0,1.458-1.611,1.444,1.444,0,0,0-1.569-1.4c-1.016-.018-2.032,0-3.048,0-1.05,0-2.1-.019-3.149.006a1.417,1.417,0,0,0-1.549,1.406A1.421,1.421,0,0,0-261.664,528.921Z"
      transform="translate(305.537 -460.031)"
      fill="url(#linear-gradient-13)"
    />
  </svg>,
  'ColorAiExamIcon',
);
